import * as fetch from '../../utils/action'
import timeutils from 'utils/wt-time-utils'
import { getTotalNumber } from './totalMethod'
import order from './modules/order'
import mall from './modules/mall'
import mallOrder from './modules/mall-order'
import detection from './modules/detetion'
import datas from './datas'
import infromation from './modules/information'
import counselor from './modules/counselor'
import customer from './modules/customer'
import dataStatistic from './modules/data-statistic'
import finanace from './modules/finance'
import otherService from './modules/other-service'
import newToOldAudit from './modules/new-to-old-audit'
import companyAndDoctor from './modules/company-and-doctor'
import appointmentSign from './modules/appointment-sign'
import poster from './modules/poster'
import integralMall from './modules/integral-mall'
import linkManage from './modules/link-manage'
import mallData from './datas/mall'
import obsDepartment from './modules/obs-department'
import famousDoctorHall from './modules/famous-doctor-hall'
let actions = {
  // 更新用户信息
  updateUserInfo (ctx, data) {
    return fetch.updateUserInfo(data).then(response => {
      ctx.dispatch('refreshUserInfo')
      return response.data
    })
  },
  // 获取用户的商城用户信息
  getCurrentUserMallUserInformation (ctx, mobile) {
    return fetch.getCurrentUserMallUserInformation(mobile).then(res => {
      return res.data
    })
  },
  // 刷新用户信息
  refreshUserInfo (ctx) {
    /* global vm */
    vm.$auth.fetch({ ...vm.$auth.options.fetchData })
  },
  // 获取手机验证码（不可删除）
  getCode (ctx, data) {
    return fetch.getCode(data)
  },
  getMenu (ctx) {
    return fetch.getMenu().then(res => {
      let result = res.data
      result = datas.getMenu(result)
      ctx.commit('menuList', result)
      return res
    })
  },
  getDivision (ctx, data) {
    return fetch.getDivision(data).then(res => {
      return res.data
    })
  },
  getResuorceUrl (ctx, data) {
    return fetch.getResuorceUrl(data).then(res => {
      return res.data
    })
  },
  insuranceClaimsLogin (ctx) {
    return fetch.insuranceClaimsLogin().then(res => {
      return res.data
    })
  },
  changePassword (ctx, data) {
    return fetch.changePassword(data).then(res => {
      return res.data
    })
  },
  invalidUserList (ctx, data) {
    return fetch.invalidUserList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallData.importedCustomer(result.data)
      return result
    })
  },
  deleteImportCustomer (ctx, id) {
    return fetch.deleteImportCustomer(id).then(res => {
      return res
    })
  },
  customerUploadTempFile (ctx, data) {
    return fetch.customerUploadTempFile(data).then(res => {
      return res
    })
  },
  importedCustomer (ctx, data) {
    return fetch.importedCustomer(data).then(res => {
      let result = getTotalNumber(res)
      result.data = mallData.importedCustomer(result.data)
      return result
    })
  },
  getBusinessDepartment (ctx) {
    return fetch.getBusinessDepartment().then(res => {
      return res.data
    })
  },
  // 省市区选择
  gbcodeAdminDivisions (ctx, data) {
    return fetch.gbcodeAdminDivisions(data).then(response => {
      return response.data
    })
  },
  // 获取投保信息列表
  getInsureList (ctx, data) {
    return fetch.getInsureList(data).then(response => {
      let result = getTotalNumber(response)
      let tempGender = {
        MALE: '男',
        FEMALE: '女'
      }
      result.data.forEach(item => {
        item.insurerGender = tempGender[item.insurerGender]
        item.guardianGender = tempGender[item.guardianGender]
        item.created_date = item.createdDate && timeutils.format(item.createdDate)
      })
      return result
    })
  },
  // 导出投保信息
  exportInsureMaterials (ctx, data) {
    return fetch.exportInsureMaterials(data).then(response => {
      return response.data
    })
  },
  // 获取投保信息的详情
  getInsureMaterialsDetail (ctx, data) {
    return fetch.getInsureMaterialsDetail(data).then(response => {
      let tempGender = {
        MALE: '男',
        FEMALE: '女'
      }
      response.data.insurer_gender = tempGender[response.data.insurerGender]
      response.data.guardian_gender = tempGender[response.data.guardianGender]
      response.data.created_date = response.data.createdDate && timeutils.format(response.data.createdDate)
      return response.data
    })
  },
  // 编辑投保信息
  updateInsureInfo (ctx, data) {
    return fetch.updateInsureInfo(data).then(response => {
      return response.data
    })
  },
  ...order,
  ...mall,
  ...mallOrder,
  ...detection,
  ...infromation,
  ...counselor,
  ...customer,
  ...dataStatistic,
  ...finanace,
  ...otherService,
  ...newToOldAudit,
  ...companyAndDoctor,
  ...appointmentSign,
  ...poster,
  ...integralMall,
  ...linkManage,
  ...obsDepartment,
  ...famousDoctorHall
}
export default actions
